import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram, FaMapMarkerAlt, FaPhone, FaEnvelope } from 'react-icons/fa';
import '../styles/Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-about">
            <div className="footer-logo">
              <div className="footer-logo-text">
                <span className="footer-logo-top">JOY WORLDWIDE</span>
                <span className="footer-logo-bottom">CONSULTANCY SERVICES</span>
              </div>
            </div>
            <p>
              Your trusted partner for global staffing and recruiting solutions.
              We connect exceptional talent with outstanding opportunities worldwide.
            </p>
            <div className="social-links">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <FaFacebookF />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                <FaTwitter />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <FaLinkedinIn />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <FaInstagram />
              </a>
            </div>
          </div>

          <div className="footer-links">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/for-employers">For Employers</Link></li>
              <li><Link to="/for-job-seekers">For Job Seekers</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer-links">
            <h4>Our Services</h4>
            <ul>
              <li><Link to="/services">Human Resources</Link></li>
              <li><Link to="/services">Global Placements</Link></li>
              <li><Link to="/services">Immigration Services</Link></li>
              <li><Link to="/services">Management Services</Link></li>
              <li><Link to="/services">Student Services</Link></li>
            </ul>
          </div>

          <div className="footer-contact">
            <h4>Contact Us</h4>
            <div className="contact-info">
              <div className="contact-item">
                <FaMapMarkerAlt />
                <span><strong>Head Office - UAE:</strong><br />Office: C1 - 1F - SF7384, C1 Building, Ajman Free Zone, AJMAN, UAE</span>
              </div>
              <div className="contact-item">
                <FaMapMarkerAlt />
                <span><strong>India Affiliate Office - BLUE COLLAR MANPOWER MGMT (BCMM):</strong><br />#52/2, 3rd Floor, 1st Main, "Mutthappa Reddy Heights", diagonally opp. Gopalan Signature Mall, Old Madras Road, Benniganahalli, Doorvaninagar, Bengaluru 560016, Karnataka.</span>
              </div>
              <div className="contact-item">
                <FaPhone />
                <span>
                  <a href="tel:+16476849045">+1 647-684-9045</a> (International)<br />
                  <a href="tel:+919380093605">+91 9380093605</a> (India)<br />
                  +91 8310932594 (WhatsApp only)
                </span>
              </div>
              <div className="contact-item">
                <FaEnvelope />
                <a href="mailto:info@joywcs.com">info@joywcs.com</a>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} JOY WORLDWIDE CONSULTANCY SERVICES. All Rights Reserved.</p>
          <div className="footer-bottom-links">
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
